// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bottom-0{\n   position: absolute;\n   bottom: 30px;\n   left: 0px;\n   width: 100%;\n}\n.bottom-60{\n   position: absolute;\n   bottom: 120px;\n    left: 0px;\n    width: 100%;\n}\n.bottom-30{\n   position: absolute;\n   bottom: 75px;\n    left: 0px;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
